import { RefObject, useEffect, useRef, useState } from 'react'

/**
 * Returns a ref which can be monitored for focus
 */
export function useInputFocus<ElementType extends HTMLElement> () {

  // * TODO - See if this can be replaced with built
  // * in focus handler in  react-hook-form
  // * --------------------------------------------------------------
  const [isFocused, setIsFocused] = useState(false)
  const isFocusedRef = useRef(isFocused)
  isFocusedRef.current = isFocused
  const rootRef = useRef<ElementType>(null)

  useEffect(() => {
    const { current } = rootRef
    if (!current) {
      return
    }

    const handler = () => {
      const isContains = current.contains(document.activeElement)
      if (isContains !== isFocusedRef.current) {
        setIsFocused(isContains)
      }
    }

    current.addEventListener('focusin', handler, false)
    current.addEventListener('focusout', handler, false)

    return () => {
      current.removeEventListener('focusin', handler, false)
      current.removeEventListener('focusout', handler, false)
    }
  }, [])

  return { isFocused, rootRef } as { isFocused: boolean, rootRef: RefObject<ElementType> }
}
